import { LIST_SEARCH, LIST_PAGE } from '../actions/listactions';

const state = { search: '', page: 0, jobtype: null };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [LIST_SEARCH]: ({ commit }, search) => {
        commit(LIST_SEARCH, search);
    },
    [LIST_PAGE]: ({ commit }, page) => {
        commit(LIST_PAGE, page);
    },
};

const mutations = {
    [LIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [LIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};